import React from 'react'
import styled from 'styled-components'
import {Box, Button, Card, Flex, Image} from 'rebass'
import {boxShadow} from "styled-system";
// import {AddCircleOutline} from "styled-icons/material";
// import IosAddCircleOutline from 'react-ionicons/lib/IosAddCircleOutline'
import IosImage from 'react-ionicons/lib/IosImage'
import MdAddCircle from 'react-ionicons/lib/MdAddCircle'
import MdLaptop from 'react-ionicons/lib/MdLaptop'
import {Paperclip} from "styled-icons/fa-solid/Paperclip";
// import MdFolderOpen from 'react-ionicons/lib/MdFolderOpen'


export const LaptopIcon = (props) => (
	<MdLaptop {...props} color={'#969a9b'}/>
)
export const Plus = (props) => (
	<MdAddCircle {...props} color={'#969a9b'}/>
)



export const SendButton = styled(Button)`
	border-radius: 5px !important;
`

// SendButton.defaultProps = {
// 	// my: '4px'
// };
// export const Plus = styled(PlusCircle)`
// 	color: #969a9b;
// 	font-size: 25px;
// `
export const ButtonWrapper = styled(Box)`
	min-width: 80px;
	max-width: 80px;
`

export const AttachmentWrapper = styled(Box)`
	min-width: 50px;
	max-width: 50px;
`

export const InputWrapper = styled(Box)`
	width: calc(100% - 130px);
`

export const ImageIcon = () => <IosImage fontSize={'50px'} color={'#969a9b'}/>


const StyledPaperclip = styled(Paperclip)`
font-size: '30px';
`

export const Folder = (props) => (
	<StyledPaperclip {...props} color={'#969a9b'} size={'20px'}/>
)

export const CardWrapper = styled(Card)`
 	min-height: 51px;
	//max-height: 51px;
	font-weight: 700;
	//@media(max-width: 500px){
	//	max-height: none;
	//}
`

export const ToolbarWrapper = styled(Card)`
 	min-height: 51px;
	max-height: 51px;
	font-weight: 700;
	//@media(max-width: 500px){
	//	max-height: none;
	//}
`

export const AttachementSection = styled(Flex)`
 ${boxShadow}
  position: relative;
  top: -157px;
  width: 200px;
  height: 80px;
	@media(max-width: 500px){
	  height: 40px;
  top: -95px;

	}
`

export const DesktopPreview = styled(Flex)`
 ${boxShadow}
  background-color: transparent;
  position: relative;
  top: -120px;

	@media(max-width: 500px){
	  position: initial;
		height: 200px;

	}
`

export const FileInputWrapper = styled(Flex)`
      display: inline-block;
	    //width: 200px;
	    height: 40px;
	    overflow: hidden;
	    position: relative;

    &  input[type="file"] {
		    font-size: 200px;
		    position: absolute;
		    top: 0;
		    right: 0;
		    opacity: 0;
		    z-index: 1000;
		 }
   

`

export const ImagePreview = styled(Image)`
	 display: block;
  max-width:345px;
  max-height:143px;
  width: auto;
  height: auto;	
  z-index: 999;

`

